import { AppBar, InputBase, Tab, Tabs } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ChangeEventHandler, useState } from "react";
import Breadcrumb from "../../Components/Navigation/Breadcrumbs/Breadcrumbs";
import { a11yProps, TabPanel } from "../../Components/Tabs/TabPanel";
import IntegrationsTable from "./IntegrationsTable";
import SearchSettingsTable from "./SearchSettingsTable";
import SiteFeaturesTable from "./SiteFeaturesTable";

export const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    backgroundColor: "transparent",
    boxShadow: "none",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    width: "85%",
    zIndex: 0,
  },
  tab: {
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      "& .MuiBox-root": {
        padding: "0px",
      },
    },
  },
  tabContainer: {},
  autocomplete: {
    width: "20%",
    paddingBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function FeaturesEnabledPage() {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };
  return (
    <div className="page-container">
      <Breadcrumb />
      <h1 className="page-title">Features Enabled</h1>
      <AppBar position="static" className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          classes={{ indicator: classes.primary }}
          className={classes.tabContainer}
        >
          <Tab label="Search Forms" {...a11yProps(0)} className={classes.tab} />
          <Tab label="Site Features" {...a11yProps(1)} className={classes.tab} />
          <Tab label="Integrations" {...a11yProps(2)} className={classes.tab} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} className={classes.tab} style={{ height: 100 }}>
        {value === 0 ? <SearchSettingsTable /> : null}
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.tab} style={{ height: 100 }}>
        {value === 1 ? <SiteFeaturesTable /> : null}
      </TabPanel>
      <TabPanel value={value} index={2} className={classes.tab} style={{ height: 100 }}>
        {value === 2 ? <IntegrationsTable /> : null}
      </TabPanel>
    </div>
  );
}

const searchStyles = makeStyles((theme) => ({
  search: {
    position: "relative",
    paddingLeft: "5px",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "rgba(0,0,0,.1)",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,.2)",
    },
    width: "20%",
    "&.Mui-focused": {
      width: "30%",
      transition: "width 0.3s",
    },
    transition: "width 0.3s",
    [theme.breakpoints.down("sm")]: {
      width: "50%",
      "&.Mui-focused": {
        width: "100%",
        transition: "width 0.3s",
      },
    },
  },
}));

export const SearchInput = ({ value, onChange }: { value: string; onChange: (value: string) => void }) => {
  const classes = searchStyles();
  const handleChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) => {
    onChange(e.currentTarget.value);
  };
  return (
    <InputBase
      className={classes.search}
      placeholder="Search..."
      onChange={handleChange}
      defaultValue={value}
    />
  );
};
